import { TCoordinate } from '../../../packages/api-models/common/json_query';

export const circlesAreEqual = (
  circle1: { radius: number; center: TCoordinate },
  circle2: { radius: number; center: TCoordinate },
): boolean =>
  circle1.radius === circle2.radius &&
  circle1.center[0] === circle2.center[0] &&
  circle1.center[1] === circle2.center[1];
